import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth"; // ✅ Importato il modulo Auth

const firebaseConfig = {
  apiKey: "AIzaSyCxqd0Z-4Wy_JEfXIHDjVbINsvuOnMSmiE",
  authDomain: "soul-rock.firebaseapp.com",
  projectId: "soul-rock",
  storageBucket: "soul-rock.firebasestorage.app",
  messagingSenderId: "369709362172",
  appId: "1:369709362172:web:e23ba81d09fd7ac6906079"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app); // ✅ Inizializzato Auth

export { db, auth };